// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type EditDashboardModalType from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncEditDashboardModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-edit-dashboard-modal" */ './index'),
	{ ssr: false },
);

const AsyncEditDashboardModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof EditDashboardModalType,
		ComponentProps<typeof EditDashboardModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="edit-dashboard-modal" fallback={<></>}>
		<AsyncEditDashboardModal {...props} />
	</Placeholder>
);

export default AsyncEditDashboardModalContainer;
